import React from "react"
import { ResultItems, ResultType } from "./result-item-styled"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import { summaryLength } from "../../../constants"
import {
  resultItem,
  resultContent,
  resultType,
  resultTypeIcon,
  resultTypeType,
  resultTitle,
  resultResume,
} from "../listResults.module.scss"
import PropTypes from "prop-types"

const ResultItem = ({ result, role }) => {
  let iconType = ""
  switch (result.internal.type) {
    case "node__carnet_d_adresse":
      iconType = "address-book"
      break
    case "node__actualites":
      iconType = "newspaper"
      break
    case "node__evenements":
      iconType = "calendar"
      break
    case "node__teleformulaires":
      iconType = "profile"
      break
    default:
      iconType = "file-empty"
  }
  return (
    <ResultItems className={resultItem} role={role}>
      <TransitionFade link={result.path.alias}>
        <div className={resultContent}>
          <ResultType className={resultType}>
            <Icon className={resultTypeIcon} size={20} icon={iconType} />
            <h3 className={resultTypeType}>
              {result.relationships.node_type.name}
            </h3>
          </ResultType>
          <h4 className={resultTitle}>{result.title}</h4>
          {result.body && (
            <p
              className={resultResume}
              dangerouslySetInnerHTML={{
                __html: SummaryTransformer(result.body, summaryLength),
              }}
            />
          )}
        </div>
      </TransitionFade>
    </ResultItems>
  )
}

ResultItem.propTypes = {
  result: PropTypes.object.isRequired,
  role: PropTypes.string,
}

export default ResultItem
